import classNames from "classnames";
import React, { PropsWithChildren } from "react";
import { useTabsContext } from "./context";

export function TabPanel({
	children,
	value,
	className,
}: PropsWithChildren<{
	value: string;
	className?: string;
}>) {
	const { activeTab } = useTabsContext();

	if (activeTab !== value) return null;

	return <div className={classNames("tab-panel", className)}>{children}</div>;
}
